import React from 'react'

const MusclesTargetSvg = () => {
    return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12Z" stroke="#062021" strokeWidth="1.5" />
        <path d="M2 12H5M19 12H22M12 22V19M12 5V2" stroke="#062021" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M10 12H14M12 14V10" stroke="#062021" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    )
}

export default MusclesTargetSvg;